module.exports = __webpack_public_path__ + "static/img/scene2.62a1f123.jpg";